/*
Use this module to check for existence of our browser extension.
Extension injects custom tag into page.
Check every 100ms up to 3500ms after document.ready for it.
If promise resolves, button is installed on current browser. If fail, button is not installed on current browser.
*/
import { onGaReady } from 'core/utils/analytics/analytics';

const detectButton = new Promise((resolve) => {
  const startTime = performance.now();
  const checkIsButtonExtensionInstalled = () =>
    document.documentElement.getAttribute('mn-button-installed') || document.querySelector('mntoolbar');

  if (checkIsButtonExtensionInstalled()) {
    resolve(true);
    const endTime = performance.now();
    const timeToDetectButton = endTime - startTime;
    sendAnalytics(timeToDetectButton);
    return;
  }

  const MAX_DELAY = 3500; // check the button for up to 3.5 seconds
  const INTERVAL = 100;
  let currentDelay = INTERVAL;

  const timerId = setInterval(() => {
    if (checkIsButtonExtensionInstalled()) {
      resolve(true);
      const endTime = performance.now();
      const timeToDetectButton = endTime - startTime;
      sendAnalytics(timeToDetectButton);
      clearInterval(timerId);
    }

    if (currentDelay >= MAX_DELAY) {
      resolve(false);
      clearInterval(timerId);
    }

    currentDelay += INTERVAL;
  }, INTERVAL);
});

function sendAnalytics(timeToDetectButton) {
  onGaReady((ReactGA) => {
    ReactGA.event('button.installed', {
      category: 'Button Detection',
      action: 'Button Detection',
      label: 'Button Installed',
      value: `${timeToDetectButton}ms`,
    });
  });
}

export default detectButton;
